<script>
    import Tabs from 'uiv/src/components/tabs/Tabs.vue';

    export default {
        extends: Tabs,

        mounted: function(){
            var hash = location.hash;
            if( typeof hash === 'string' && hash.includes( '#tab-id=' ) ){
                var tabId = hash.replace( '#tab-id=', '' );

                this.select( parseInt( tabId ) );
            }
        },

        watch: {
            activeIndex: function( tabId ){
                if( history.pushState ){
                    history.pushState( null, null, '#tab-id=' + tabId );
                }
                else{
                    location.hash = '#tab-id=' + tabId;
                }
            }
        }
    }
</script>